// pt葡萄牙
export default {
    CustomSelect: {
        '请选择': 'Selecione',
    },
    TopNav: {
        '创作者': 'Criador',
        '游客': 'Visitante',
        '请登录后体验完整功能': 'Faça login para acessar todos os recursos',
        '登录': 'Entrar',
        '免费试用': 'Teste grátis',
        '退出登录': 'Sair',
        '个人中心': 'Minha conta',
        '我的视频': 'Meus vídeos',
        '额度管理': 'Gestão de créditos',
        '首页': 'Início',
        'AI创作': 'Criação com IA',
        '多参考': 'Multirreferência',
        '文本视频': 'Texto para vídeo',
        '图片视频': 'Imagem para vídeo',
        '文生图': 'Texto para imagem',
        '图生图': 'Imagem para imagem',
        '会员中心': 'Central de assinante',
        '概览': 'Visão geral',
        '我的创作': 'Minhas criações',
        '账单管理': 'Gestão de faturas',
        '生成任务': 'Tarefas de geração',
        '价格': 'Preços',
        '新闻资讯': 'Notícias',
        '确定要退出登录吗？': 'Deseja sair?',
        '提示': 'Dica',
        '确定': 'Confirmar',
        '取消': 'Cancelar',
        '退出成功': 'Saiu com sucesso',
        '视频展示': 'vídeo'
    },
    AiLayout: {
        'AI创作中心': 'Central de criação com IA',
        '视频生成': 'Gerar vídeo',
        '图片生成': 'Gerar imagem',
        '我的作品': 'Minhas obras',
        '我的创作': 'Minhas criações',
        '今日剩余额度': 'Créditos restantes hoje',
        '多参考': 'Multirreferência',
        '文本视频': 'Texto para vídeo',
        '图片视频': 'Imagem para vídeo',
        '文生图': 'Texto para imagem',
        '图生图': 'Imagem para imagem',
    },
    HomeLayout: {
        '下一代AI视频生成平台': 'Plataforma de nova geração para geração de vídeo com IA, transforme ideias em realidade instantaneamente',
        '产品': 'Produtos',
        'AI视频': 'Vídeo com IA',
        '价格方案': 'Planos de preços',
        '新闻资讯': 'Notícias',
        '支持': 'Suporte',
        '帮助中心': 'Central de ajuda',
        'API文档': 'Documentação da API',
        '常见问题': 'Perguntas frequentes',
        '法律': 'Jurídico',
        '服务条款': 'Termos de serviço',
        '隐私政策': 'Política de privacidade',
        '使用协议': 'Acordo de uso',
        '版权所有': 'Todos os direitos reservados',
        '客服邮箱': 'E-mail de suporte',
        '复制邮箱': 'Copiar e-mail',
        '开发中': 'Em desenvolvimento, aguarde!',
        '链接已复制到剪贴板': 'Link copiado para a área de transferência',
    },
    MyLayout: {
        '创作者': 'Criador',
        '退出登录': 'Sair',
        '概览': 'Visão geral',
        '我的创作': 'Minhas criações',
        '会员中心': 'Central de assinante',
        '额度管理': 'Gestão de créditos',
        '账单管理': 'Gestão de faturas',
        '生成任务': 'Tarefas de geração',
        '确定要退出登录吗？': 'Deseja sair?',
        '提示': 'Dica',
        '确定': 'Confirmar',
        '取消': 'Cancelar',
        '退出成功': 'Saiu com sucesso'
    },
    Image: {
        "文本生成图片": "Texto para imagem",
        "图片生成图片": "Imagem para imagem",
        "用文字描述": "Descreva com palavras a imagem que deseja",
        "上传图片素材": "Carregue material de imagem, suporta geração múltipla",
        "图片描述": "Descrição da imagem",
        "描述您想要的图片": "Descreva detalhadamente o conteúdo da imagem que deseja gerar, suporta português ou inglês...",
        "提示描述越详细效果越好": "Dica: Quanto mais detalhada a descrição, melhor o resultado da geração",
        "图片素材": "Material de imagem",
        "预览图片": "Pré-visualizar",
        "上传图片": "Carregar imagem",
        "支持格式JPGPNG": "Suporta formatos JPG, PNG",
        "最多": "Máximo",
        "张图片": "imagem(ns)",
        "超过大小限制": "Excede o limite de 10MB",
        "不是图片文件": "Arquivo de imagem inválido",
        "最多上传": "Carregamento máximo",
        "请先上传图片": "Carregue o material de imagem primeiro",
        "请选择要生成的图片": "Selecione a imagem a ser gerada",
        "生成结果": "Resultado da geração",
        "重新生成成功": "Regeneração bem-sucedida",
        "模型": "Modelo de IA",
        "请选择模型": "Selecione o modelo de geração",
        "分辨率": "Resolução de saída",
        "请选择分辨率": "Selecione a resolução",
        "图片比例": "Proporção da imagem",
        "补充描述": "Descrição adicional (opcional)",
        "补充描述提示": "Opcional, descreva quaisquer efeitos ou estilos adicionais que deseja para a imagem",
        "开始绘制": "Começar a desenhar",
        "开始生成": "Iniciar geração",
        "生成中": "Gerando, aguarde...",
        "生成成功": "Geração bem-sucedida",
        "图片生成成功": "Imagem gerada com sucesso!",
        "作品已保存到我的作品": "Obra salva em 'Minhas obras'",
        "继续创作": "Continuar criando",
        "查看作品": "Ver obra",
        "请输入图片描述": "Digite a descrição da imagem"
    },
    MyCreation: {
        '我的创作': 'Minhas criações',
        '查看和管理您的所有作品': 'Visualize e gerencie todas as suas obras',
        '预览': 'Pré-visualizar',
        '下载': 'Baixar',
        '编辑': 'Editar',
        '分享': 'Compartilhar',
        '删除': 'Excluir',
        '暂无作品': 'Nenhuma obra',
        '去创作': 'Criar',
        '确定删除': 'Confirmar exclusão',
        '确定要删除作品': 'Deseja excluir a obra',
        '吗？': '?',
        '此操作不可恢复': 'Esta ação é irreversível, tenha cuidado!',
        '取消': 'Cancelar',
        '分享作品': 'Compartilhar obra',
        '复制链接': 'Copiar link',
        '全部': 'Todos',
        '视频': 'Vídeo',
        '图片': 'Imagem',
        '正在下载:': 'Baixando: ',
        '链接已复制到剪贴板': 'Link copiado para a área de transferência',
        '删除成功': 'Excluído com sucesso'
    },
    Video: {
        "文本生成视频": "Texto para vídeo",
        "图片生成视频": "Imagem para vídeo",
        "智能视频生成": "Geração inteligente de vídeo",
        "输入文字描述": "Digite uma descrição textual",
        "上传1-9张图片": "Carregue 1-9 imagens",
        "上传图片视频音频": "Carregar imagem/vídeo/áudio",
        "视频描述": "Descrição do vídeo",
        "描述您想要的视频场景": "Descreva a cena de vídeo desejada",
        "提示": "Dica",
        "图片素材": "Material de imagem",
        "最多上传": "Carregamento máximo",
        "张": "imagem(ns)",
        "预览": "Pré-visualizar",
        "上传图片": "Carregar imagem",
        "支持格式": "Formatos JPG, PNG, máximo 10MB por arquivo, máximo",
        "AI": "A IA integra-se inteligentemente e gerará transições suaves",
        "动态描述": "Descrição do movimento",
        "描述您希望图片如何动起来": "Descreva como deseja que a imagem se mova",
        "个": "item(ns)",
        "上传视频": "Carregar vídeo",
        "上传音频": "Carregar áudio",
        "描述您希望视频呈现的效果": "Descreva o efeito desejado para o vídeo",
        "模型": "Modelo",
        "请选择模型": "Selecione o modelo",
        "分辨率": "Resolução",
        "请选择分辨率": "Selecione a resolução",
        "宽高比": "Proporção",
        "视频时长": "Duração do vídeo",
        "生成音频": "Gerar áudio",
        "开启音效": "Ativar efeitos sonoros",
        "静音模式": "Modo silencioso",
        "音频提示": "Dica: O áudio carregado será usado como música de fundo. Se nenhum áudio for carregado, a IA gerará música automaticamente",
        "开始生成": "Iniciar geração",
        "积分": "Créditos",
        "生成中": "Gerando",
        "生成成功": "Geração bem-sucedida",
        "视频生成成功！": "Vídeo gerado com sucesso!",
        "作品已保存到": "Obra salva em 'Minhas obras'",
        "继续创作": "Continuar criando",
        "查看作品": "Ver obra",
        "视频预览": "Pré-visualização do vídeo",
        "关闭": "Fechar",
        "下载视频": "Baixar vídeo",
        "您的浏览器不支持视频播放": "Seu navegador não suporta reprodução de vídeo",
        "生成进度": "Progresso da geração",
        "描述": "Descrição",
        "时长": "Duração",
        "秒": "segundos",
        "视频素材": "Material de vídeo",
        "音频素材": "Material de áudio",
        "双图融合模式": "Modo de fusão de duas imagens",
        "开始下载视频": "Iniciar download do vídeo",
        "请输入视频描述": "Digite a descrição do vídeo",
        "请至少上传一张图片": "Carregue pelo menos uma imagem",
        "请至少上传一张图片或一个视频": "Carregue pelo menos uma imagem ou um vídeo",
        "最多只能上传": "Carregamento máximo",
        "超过": "Excede",
        "限制": "limite",
        "不是图片文件": "Arquivo de imagem inválido",
        "不是视频文件": "Arquivo de vídeo inválido",
        "不是音频文件": "Arquivo de áudio inválido"
    },
    Forgot: {
        "找回密码": "Recuperar senha",
        "请输入您的邮箱，我们将发送验证码": "Digite seu e-mail, enviaremos um código de verificação",
        "密码重置成功，请使用新密码登录": "Senha redefinida com sucesso, faça login com a nova senha",
        "密码重置成功": "Senha redefinida com sucesso",
        "您的密码已成功重置，请使用新密码登录": "Sua senha foi redefinida com sucesso, faça login com sua nova senha",
        "立即登录": "Entrar agora",
        "邮箱": "E-mail",
        "请输入注册邮箱": "Digite o e-mail registrado",
        "发送验证码": "Enviar código",
        "请输入验证码": "Digite o código de verificação",
        "验证码": "Código de verificação",
        "新密码": "Nova senha",
        "设置新密码": "Definir nova senha",
        "确认新密码": "Confirmar nova senha",
        "再次输入新密码": "Digite a nova senha novamente",
        "重置密码": "Redefinir senha",
        "返回登录": "Voltar ao login",
        "验证中": "Verificando",
        "重置中": "Redefinindo",
        "弱": "Fraco",
        "中": "Médio",
        "强": "Forte",
        "请输入邮箱地址": "Digite o endereço de e-mail",
        "请输入正确的邮箱格式": "Digite um formato de e-mail válido",
        "验证码应为6位数字": "O código de verificação deve ter 6 dígitos",
        "请输入新密码": "Digite uma nova senha",
        "密码至少需要6位": "A senha deve ter pelo menos 6 caracteres",
        "请再次输入新密码": "Digite a nova senha novamente",
        "两次输入的密码不一致": "As senhas inseridas não coincidem",
        "验证码已发送": "Código de verificação enviado"
    },
    Login: {
        "下一代AI视频生成平台": "Plataforma de nova geração para geração de vídeo com IA",
        "一键生成": "Geração com um clique",
        "支持4K超高清输出": "Suporte a saída 4K Ultra HD",
        "多种风格模板任选": "Escolha entre vários modelos de estilo",
        "商用授权无忧使用": "Licença comercial, use sem preocupações",
        "欢迎回来": "Bem-vindo de volta",
        "登录您的账号继续创作": "Faça login para continuar criando",
        "邮箱": "E-mail",
        "请输入邮箱地址": "Digite o endereço de e-mail",
        "密码": "Senha",
        "请输入您的密码": "Digite sua senha",
        "记住我": "Lembrar-me",
        "忘记密码？": "Esqueceu a senha?",
        "登录": "Entrar",
        "登录中": "Entrando",
        "还没有账号？": "Ainda não tem uma conta?",
        "立即注册": "Registrar agora",
        "请输入正确的邮箱格式": "Digite um formato de e-mail válido",
        "请输入密码": "Digite a senha",
        "密码至少需要6位": "A senha deve ter pelo menos 6 caracteres",
        "密码不能超过20位": "A senha não pode exceder 20 caracteres",
        "登录成功": "Login bem-sucedido"
    },
    Register: {
        "创建账号": "Criar conta",
        "开始您的AI视频创作之旅": "Inicie sua jornada de criação de vídeo com IA",
        "姓名": "Nome",
        "请输入您的姓名": "Digite seu nome",
        "邮箱": "E-mail",
        "请输入邮箱地址": "Digite o endereço de e-mail",
        "获取验证码": "Obter código",
        "验证码": "Código de verificação",
        "请输入验证码": "Digite o código de verificação",
        "密码": "Senha",
        "设置密码": "Definir senha",
        "确认密码": "Confirmar senha",
        "再次输入密码": "Digite a senha novamente",
        "我已阅读并同意": "Li e concordo com os",
        "服务条款": "Termos de serviço",
        "和": "e",
        "隐私政策": "Política de privacidade",
        "注册中": "Registrando",
        "已有账号？": "Já tem uma conta?",
        "立即登录": "Entrar agora",
        "弱": "Fraco",
        "中": "Médio",
        "强": "Forte",
        "请输入姓名": "Digite o nome",
        "姓名至少需要2个字符": "O nome deve ter pelo menos 2 caracteres",
        "姓名不能超过20个字符": "O nome não pode exceder 20 caracteres",
        "请输入正确的邮箱格式": "Digite um formato de e-mail válido",
        "验证码应为6位数字": "O código de verificação deve ter 6 dígitos",
        "请输入密码": "Digite a senha",
        "密码至少需要6位": "A senha deve ter pelo menos 6 caracteres",
        "密码不能超过20位": "A senha não pode exceder 20 caracteres",
        "请再次输入密码": "Confirme a senha",
        "两次输入的密码不一致": "As senhas inseridas não coincidem",
        "验证码已发送": "Código de verificação enviado",
        "注册成功": "Registro bem-sucedido"
    },
    Faq: {
        '常见问题': 'Perguntas frequentes',
        '您在使用过程中遇到的问题': 'Problemas que você encontra durante o uso, encontre respostas aqui',
        '搜索您的问题': 'Pesquise sua pergunta...',
        '没有找到相关的问题': 'Nenhuma pergunta relacionada encontrada',
        '查看全部问题': 'Ver todas as perguntas',
        '没有找到您想要的答案？': 'Não encontrou a resposta que procurava?',
        '我们的客服团队随时为您提供帮助': 'Nossa equipe de suporte está disponível para ajudá-lo',
        '复制客服邮箱': 'Copiar e-mail de suporte',
        '链接已复制到剪贴板': 'Link copiado para a área de transferência'
    },
    Home: {
        '立即订阅': 'Inscreva-se agora',
        'AI视频生成新时代': 'Nova era da geração de vídeo com IA',
        '用文字创造': 'Crie com palavras',
        '无限视频': 'Vídeos ilimitados',
        '让每个人都能成为视频创作者': 'Permita que todos se tornem criadores de vídeo. Basta digitar uma descrição textual para obter vídeos de IA de alta qualidade e únicos.',
        '免费开始': 'Começar grátis',
        '观看演示': 'Ver demonstração',
        'AI生成': 'Gerar com IA',
        'AI视频': 'Vídeo com IA',
        '三步轻松生成专业视频': 'Três passos simples para gerar vídeos profissionais',
        '输入提示词': 'Digite o prompt',
        '用文字描述您想要的视频内容': 'Descreva com palavras o conteúdo do vídeo desejado, quanto mais detalhado melhor',
        '智能生成': 'Geração inteligente',
        'AI模型自动理解并创作': 'O modelo de IA entende e cria automaticamente, a renderização é concluída em minutos',
        '下载作品': 'Baixar obra',
        '高清视频生成完成': 'Geração de vídeo HD concluída, pronto para download e uso imediato',
        'AI视频生成': 'Geração de vídeo com IA',
        '精彩视频': 'Digite uma descrição textual, a IA gerará um vídeo incrível para você',
        '描述您想要的视频场景': 'Descreva a cena de vídeo desejada, por exemplo: Um gato brincando sob uma cerejeira em flor, a luz do sol filtrando-se através das pétalas...',
        '生成中': 'Gerando...',
        '生成视频': 'Gerar vídeo',
        'AI图片': 'Imagem com IA',
        '精美图片': 'Digite uma descrição textual, a IA gerará uma imagem incrível para você',
        '描述您想要的图片场景': 'Descreva a cena de imagem desejada, por exemplo: Horizonte de uma cidade futurista, luzes de neon piscando, estilo cyberpunk...',
        '生成图片': 'Gerar imagem',
        '强大功能': 'Recursos poderosos',
        '让视频创作变得简单有趣': 'Torne a criação de vídeos simples e divertida',
        '案例展示': 'Exemplos',
        '来看看用户使用': 'Veja as obras incríveis criadas pelos',
        '创作的精彩作品': 'usuários',
        '新闻资讯': 'Notícias',
        '了解': 'Descubra as',
        '的最新动态和产品更新': 'últimas novidades e atualizações de produtos',
        '查看更多': 'Ver mais',
        '热门': 'Populares',
        '最新': 'Recentes',
        '阅读更多': 'Leia mais',
        '选择适合您的方案': 'Escolha o plano ideal para você',
        '灵活的定价': 'Preços flexíveis para atender diferentes necessidades',
        '视频预览': 'Pré-visualização do vídeo',
        '生成成功': 'Geração bem-sucedida',
        '作品已保存到': 'Obra salva em "Minhas criações"',
        '继续创作': 'Continuar criando',
        '查看作品': 'Ver obra',
        '请输入视频描述': 'Digite a descrição do vídeo',
        '视频生成成功！': 'Vídeo gerado com sucesso!',
        '请输入图片描述': 'Digite a descrição da imagem',
        '图片生成成功！': 'Imagem gerada com sucesso!',
    },
    News: {
        '新闻资讯': 'Notícias',
        '了解': 'Descubra as',
        '的最新动态和产品更新': 'últimas novidades e atualizações de produtos',
        '精选': 'Destaques',
        '阅读': 'Ler',
        '点赞': 'Curtir',
        '热门': 'Populares',
        '最新': 'Recentes',
        '阅读更多': 'Leia mais',
        '加载中': 'Carregando...',
        '暂无新闻': 'Nenhuma notícia',
        '清除筛选': 'Limpar filtro',
        '加载新闻失败': 'Falha ao carregar notícias, tente novamente mais tarde',
    },
    Price: {
        '选择适合您的方案': 'Escolha o plano ideal para você',
        '灵活的定价': 'Preços flexíveis para atender diferentes necessidades',
        '包月': 'Mensal',
        '包年': 'Anual',
        '购买积分': 'Comprar créditos',
        '只需要几个视频': 'Precisa apenas de alguns vídeos? Sem assinatura, compre diretamente um pacote de créditos',
        '产品大全': 'Catálogo de produtos',
        '了解': 'Saiba mais sobre',
        '全系列产品的详细信息和支付方式': 'informações detalhadas e métodos de pagamento para toda a linha de produtos'
    },
    Billing: {
        '账单管理': 'Gestão de faturas',
        '账户余额': 'Saldo da conta',
        '本月支出': 'Despesas deste mês',
        '订单数量': 'Número de pedidos',
        '账单列表': 'Lista de faturas',
        '请选择类型': 'Selecione o tipo',
        '请选择时间范围': 'Selecione o período',
        '订单号': 'Número do pedido',
        '类型': 'Tipo',
        '金额': 'Valor',
        '状态': 'Status',
        '时间': 'Data',
        '操作': 'Ação',
        '查看详情': 'Ver detalhes',
        '下载发票': 'Baixar fatura',
        '暂无作品': 'Nenhuma obra',
        '去创作': 'Criar',
        '支付方式': 'Método de pagamento',
        '添加支付方式': 'Adicionar método',
        '默认': 'Padrão',
        '设为默认': 'Definir como padrão',
        '编辑': 'Editar',
        '删除': 'Excluir',
        '账单详情': 'Detalhes da fatura',
        '交易流水号': 'Número da transação',
        '关闭': 'Fechar',
        '账号': 'Conta/Número do cartão',
        '请输入账号或卡号': 'Digite o número da conta ou cartão',
        '姓名': 'Nome',
        '请输入持卡人姓名': 'Digite o nome do titular do cartão',
        '有效期': 'Data de validade',
        '请输入CVV码': 'Digite o código CVV',
        '取消': 'Cancelar',
        '确认添加': 'Confirmar adição',
        '确认修改': 'Confirmar alteração',
        '确认删除': 'Confirmar exclusão',
        '编辑支付方式': 'Editar método de pagamento',
        '确定要删除支付方式': 'Deseja excluir este método de pagamento?',
        '删除后不可恢复': 'A exclusão é irreversível, tenha cuidado!',
        '请输入账号': 'Digite o número da conta/cartão',
        '添加成功': 'Adicionado com sucesso',
        '修改成功': 'Alterado com sucesso',
        '已设为默认支付方式': 'Definido como método de pagamento padrão',
        '删除成功': 'Excluído com sucesso',
    },
    Credit: {
        '额度管理': 'Gestão de créditos',
        '当前可用额度': 'Créditos disponíveis atualmente',
        '升级会员': 'Upgrade de assinatura',
        '本月已用': 'Usado este mês',
        '视频生成': 'Geração de vídeo',
        'AI图片': 'Imagem com IA',
        '其他': 'Outros',
        '购买额度包': 'Comprar pacote de créditos',
        '最受欢迎': 'Mais popular',
        '额度': 'Créditos',
        '立即购买': 'Comprar agora',
        '使用记录': 'Histórico de uso',
        '操作': 'Ação',
        '类型': 'Tipo',
        '额度变动': 'Alteração de créditos',
        '时间': 'Data',
        '购买': 'Comprar',
        '确认购买': 'Confirmar compra',
        '金额': 'Valor: ',
        '获得': 'Obter',
        '取消': 'Cancelar',
        '今天': 'Hoje',
        '昨天': 'Ontem',
    },
    Dashboard: {
        '欢迎回来': 'Bem-vindo de volta,',
        '创建新视频': 'Criar novo vídeo',
        '本月生成次数': 'Gerações neste mês',
        '剩余额度': 'Créditos restantes',
        '总视频数': 'Total de vídeos',
        '会员状态': 'Status da assinatura',
        '最近生成': 'Gerações recentes',
        '查看全部': 'Ver todos',
        '视频预览': 'Pré-visualização do vídeo',
        '视频生成中': 'Vídeo sendo gerado, aguarde para a pré-visualização',
    },
    Membership: {
        '会员中心': 'Central de assinante',
        '当前方案': 'Plano atual',
        'Pro 会员': 'Membro Pro',
        '专业创作者首选': 'A escolha ideal para criadores profissionais',
        '月': 'mês',
        '会员有效期': 'Validade da assinatura',
        '剩余天数': 'Dias restantes',
        '续费会员': 'Renovar assinatura',
        '取消订阅': 'Cancelar assinatura',
        '本月使用情况': 'Uso deste mês',
        '视频生成': 'Geração de vídeo',
        '次': 'vezes',
        '额度使用': 'Uso de créditos',
        '快速生成': 'Geração rápida',
        '升级方案': 'Upgrade de plano',
        '联系销售': 'Contatar vendas',
        '会员权益': 'Benefícios de assinante',
        '续费后将延长会员有效期30天': 'A renovação estenderá a assinatura por 30 dias',
        '取消': 'Cancelar',
        '确认续费': 'Confirmar renovação',
        '取消后您将失去所有会员权益': 'Após o cancelamento, você perderá todos os benefícios, os créditos restantes serão mantidos',
        '再想想': 'Pensar novamente',
        '确认取消': 'Confirmar cancelamento',
        '姓名': 'Nome',
        '请输入您的姓名': 'Digite seu nome',
        '请输入姓名': 'Digite o nome',
        '公司': 'Empresa',
        '请输入公司名称': 'Digite o nome da empresa',
        '邮箱': 'E-mail',
        '请输入邮箱地址': 'Digite o endereço de e-mail',
        '请输入邮箱': 'Digite o e-mail',
        '请输入正确的邮箱格式': 'Digite um formato de e-mail válido',
        '需求': 'Necessidade',
        '请描述您的需求': 'Descreva sua necessidade',
        '提交': 'Enviar',
        '请填写需求': 'Por favor, descreva sua necessidade',
        '续费成功': 'Renovação bem-sucedida! Assinatura estendida',
        '已取消订阅': 'Assinatura cancelada, a assinatura expirará no final do período',
        '提交成功': 'Enviado com sucesso, entraremos em contato em breve!',
    },
    Task: {
        '生成任务': 'Tarefas de geração',
        '新建任务': 'Nova tarefa',
        '进行中': 'Em andamento',
        '已完成': 'Concluída',
        '失败': 'Falhou',
        '队列中': 'Na fila',
        '活跃任务': 'Tarefas ativas',
        '刷新': 'Atualizar',
        '暂无活跃任务': 'Nenhuma tarefa ativa',
        '预计剩余': 'Tempo restante estimado',
        '暂停': 'Pausar',
        '继续': 'Continuar',
        '取消': 'Cancelar',
        '最近完成': 'Concluídas recentemente',
        '查看全部': 'Ver todos',
        '暂无完成的任务': 'Nenhuma tarefa concluída',
        '播放': 'Reproduzir',
        '下载': 'Baixar',
        '分享': 'Compartilhar',
        '确认取消': 'Confirmar cancelamento',
        '确定要取消任务吗': 'Deseja realmente cancelar a tarefa?',
        '已消耗的额度将无法退还': 'Os créditos consumidos não serão reembolsados',
        '返回': 'Voltar',
        '分享作品': 'Compartilhar obra',
        '复制链接': 'Copiar link',
        '任务列表已刷新': 'Lista de tarefas atualizada',
        '已暂停': 'Pausada',
        '生成中': 'Gerando',
        '已恢复': 'Retomada',
        '任务已取消': 'Tarefa cancelada',
        '链接已复制到剪贴板': 'Link copiado para a área de transferência',
    },
    VideoShow: {
        '示例': 'Exemplos',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': 'Uma seleção criteriosa de clipes da nossa biblioteca de demonstração. Clique em qualquer cartão para começar a gerar conteúdo com estilo semelhante.',
        '全部': 'Todos',
        '电影感': 'Cinematográfico',
        '角色': 'Personagens',
        '产品': 'Produtos',
        '自然': 'Natureza',
        '趣味': 'Divertido',
        '加载中': 'Carregando',
        '暂无展示': 'Nenhuma demonstração disponível',
        '视频预览': 'Pré-visualização de vídeo',
    },
    Request: {
        '加载中': 'Carregando...',
        '您已退出登录': 'Você saiu da conta, pode fazer login novamente',
        '确认退出': 'Confirmar saída',
        '重新登录': 'Fazer login novamente',
        '错误': 'Erro',
        '网络错误': 'Erro de rede',
        '下载中': 'Baixando...'
    },
    Other: {
        '剩余额度': 'Saldo restante',
        '去登录': 'Fazer login',
        '请登录后查看': 'Por favor, faça login para visualizar',
        '任务': 'Tarefa',
        '可在「生成任务」中查看详情': ', você pode ver os detalhes em "Tarefas de Geração"',
        '查看详情': 'Ver detalhes',
        '排队中': 'Na fila',
        '运行中': 'Em execução',
        '取消': 'Cancelar',
        '成功': 'Sucesso',
        '失败': 'Falhou',
        '超时': 'Tempo esgotado',
        '最后更新': 'Última atualização:',
        '视频生成': 'Geração de vídeo',
        '活跃用户': 'Usuários ativos',
        '用户评分': 'Avaliação dos usuários',
        '万': 'mil',
        '快速生成': 'Geração rápida',
        '先进的AI模型': 'Modelos de IA avançados que geram vídeos de alta qualidade em minutos',
        '多种风格': 'Múltiplos estilos',
        '多种风格任您选择': 'Realista, anime, artístico e muito mais, escolha o seu estilo',
        '高清输出': 'Saída de alta definição',
        '支持4K超高清视频输出': 'Suporta saída de vídeo 4K Ultra HD, com detalhes nítidos',
        '商用授权': 'Licença comercial',
        '生成的视频可用于商业用途': 'Os vídeos gerados podem ser usados para fins comerciais, sem preocupações com direitos autorais',
        '原价': 'Preço original',
        '积分价格说明': 'Explicação dos preços dos créditos',
        '系列': 'Série',
        '模型': 'Modelo',
        '分辨率': 'Resolução',
        '积分': 'Créditos',
        '秒': 'segundo',
        '秒示例': 'segundos (exemplo)',
        '图片模型': 'Modelo de imagem',
        '图片为': 'A imagem é',
        '系列产品': 'Produtos da série, atualmente suporta',
        '支持使用任意机型查看完整体验': ', suporta o uso de qualquer dispositivo para uma experiência completa.',
        '计费方式': 'Método de faturamento',
        '张': 'imagem(ns)',
        '按生成张数计费': 'Faturamento baseado no número de imagens geradas',
        '普通用户': 'Usuário comum',
        '无记录': 'Sem registros',
        '总支出': 'Despesa total',
        '月总使用': 'Uso total mensal',
        '月视频使用': 'Uso mensal de vídeo',
        '月图片使用': 'Uso mensal de imagem',
        '生成成功': 'Geração bem-sucedida',
        '视频总生成': 'Total de vídeos gerados',
        '图片总生成': 'Total de imagens geradas',
        '生成中': 'Gerando, aguarde 1-3 minutos',
        '来自我们演示库的一套精心挑选的剪辑片段': 'Uma coleção de clipes cuidadosamente selecionados da nossa biblioteca de demonstração.',
        '最近7天': 'Últimos 7 dias',
        '最近30天': 'Últimos 30 dias',
        '本月': 'Este mês',
        '上月': 'Mês passado',
    }
}